{
  "BULK_ACTION": {
    "CONVERSATIONS_SELECTED": "Odabrano razgovora: {conversationCount}",
    "AGENT_SELECT_LABEL": "Odaberite agenta",
    "ASSIGN_CONFIRMATION_LABEL": "Jeste li sigurni da želite dodijeliti {conversationCount} {conversationLabel} agentu",
    "UNASSIGN_CONFIRMATION_LABEL": "Jeste li sigurni da želite poništiti dodjelu za {conversationCount} {conversationLabel}?",
    "GO_BACK_LABEL": "Natrag",
    "ASSIGN_LABEL": "Dodijeli",
    "YES": "Da",
    "SEARCH_INPUT_PLACEHOLDER": "Pretraži",
    "ASSIGN_AGENT_TOOLTIP": "Dodijeli agentu",
    "ASSIGN_TEAM_TOOLTIP": "Dodijeli timu",
    "ASSIGN_SUCCESFUL": "Razgovori uspješno dodijeljeni.",
    "ASSIGN_FAILED": "Dodjela razgovora nije uspjela. Pokušajte ponovno.",
    "RESOLVE_SUCCESFUL": "Razgovori uspješno riješeni.",
    "RESOLVE_FAILED": "Rješavanje razgovora nije uspjelo. Pokušajte ponovno.",
    "ALL_CONVERSATIONS_SELECTED_ALERT": "Odabrani su samo razgovori vidljivi na ovoj stranici.",
    "AGENT_LIST_LOADING": "Učitavanje agenata",
    "UPDATE": {
      "CHANGE_STATUS": "Promijeni status",
      "SNOOZE_UNTIL": "Odgodi",
      "UPDATE_SUCCESFUL": "Status razgovora uspješno ažuriran.",
      "UPDATE_FAILED": "Ažuriranje razgovora nije uspjelo. Pokušajte ponovno."
    },
    "LABELS": {
      "ASSIGN_LABELS": "Dodijeli oznake",
      "NO_LABELS_FOUND": "Nema pronađenih oznaka za",
      "ASSIGN_SELECTED_LABELS": "Dodijeli odabrane oznake",
      "ASSIGN_SUCCESFUL": "Oznake uspješno dodijeljene.",
      "ASSIGN_FAILED": "Dodjela oznaka nije uspjela. Pokušajte ponovno."
    },
    "TEAMS": {
      "TEAM_SELECT_LABEL": "Odaberite tim",
      "NONE": "Nijedan",
      "NO_TEAMS_AVAILABLE": "Na ovaj račun još nisu dodani timovi.",
      "ASSIGN_SELECTED_TEAMS": "Dodijeli odabranom timu.",
      "ASSIGN_SUCCESFUL": "Timovi uspješno dodijeljeni.",
      "ASSIGN_FAILED": "Dodjela tima nije uspjela. Pokušajte ponovno."
    },
    "MERGE": {
      "TOOLTIP": "Spoji razgovore",
      "TITLE": "Spoji razgovore",
      "DESCRIPTION": "Odaberite ciljni razgovor. Svi ostali odabrani razgovori bit će spojeni u njega — njihove poruke bit će premještene u ciljni razgovor, a izvorni razgovori bit će izbrisani.",
      "TARGET_LABEL": "Ciljni razgovor (bit će zadržan)",
      "SOURCES_LABEL": "Izvorni razgovori (bit će izbrisani)",
      "SELECT_TARGET": "Odaberite razgovor kao cilj spajanja",
      "WARNING": "Upozorenje: Ova radnja se ne može poništiti. Poruke iz svih izvornih razgovora bit će premještene u ciljni razgovor, a izvorni razgovori bit će trajno izbrisani.",
      "SUBMIT": "Spoji razgovore",
      "CANCEL": "Odustani",
      "SUCCESS_MESSAGE": "Razgovori uspješno spojeni",
      "ERROR_MESSAGE": "Spajanje razgovora nije uspjelo. Pokušajte ponovno.",
      "CONFIRM": {
        "TITLE": "Potvrdi spajanje",
        "DESCRIPTION": "Jeste li sigurni da želite spojiti {sourceCount} razgovora u #{targetId}? Ova radnja se ne može poništiti.",
        "YES": "Da, spoji",
        "CANCEL": "Odustani"
      }
    }
  }
}
